import { render, staticRenderFns } from "./OsobaGrupaStatusaDetails.vue?vue&type=template&id=67c8da34&scoped=true&"
import script from "./OsobaGrupaStatusaDetails.vue?vue&type=script&lang=js&"
export * from "./OsobaGrupaStatusaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8da34",
  null
  
)

export default component.exports